<template v-if="flagComponents == true">
  <div>
    <v-col cols="12" sm="12" md="12"><v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line
        align="left">
        Interpretación
      </v-banner>
    </v-col>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row dense align="baseline" justify="center" class="d-flex flex-wrap text-center mb-2">
        <v-col cols="12" md="5" xl="3" sm="12">
          <v-autocomplete v-model="model.templateHTML" @change="(event) => changeTemplateInterpretation(event)"
            no-data-text="Sin resultados" :items="listTemplates" label="Seleccionar plantilla" clearable
            append-icon="mdi-file-word" :disabled="reported" />
        </v-col>
        <v-col cols="1" md="1" xl="1" sm="12" class="px-0" align="left">
          <v-btn fab x-small color="primary" @click="showModalTemplate = true">
            <v-icon>
              mdi-wrench
            </v-icon>
          </v-btn> 
        </v-col>
        <v-col v-if="!isPDF()" cols="12" md="3" xl="3" sm="12">
          <v-btn color="secondary" @click="openSliderImages()" :disabled="reported" v-if="!isPDF()">
            <v-icon left> mdi-folder-multiple-image </v-icon>
            Agregar imágenes
          </v-btn>
        </v-col>
        <v-col v-if="!isPDF() && model.nameModality === 'COLPOSCOPIA'" cols="12" md="3">
          <v-btn color="secondary"
                @click="openAttachments()"
                :disabled="reported">
            <v-icon left>mdi-folder-multiple-image</v-icon>
            Ver archivos anexos
          </v-btn>
        </v-col>
        
        <v-col v-if="isPDF()" cols="12" md="3" xl="3" sm="12">
          <v-btn color="secondary" @click="seeOrHideViewer()" :disabled="reported || loadingImages" v-if="isPDF()">
            <v-icon left> mdi-file-document-outline </v-icon>
            {{
      loadingImages
        ? "Cargando informe.."
        : dialogViewer
          ? "Ocultar informe"
          : "Ver informe"
    }}
          </v-btn>
        </v-col>

        <v-col cols="12" md="3" xl="3" sm="12" v-if="$utilFront.withPermission($prm.INTERPRETATION_VISUALIZER)">
          <v-btn color="warning" @click="downloadViewer(model)" :disabled="reported">
            <v-icon left> mdi-eye </v-icon>
            Visualizador
          </v-btn>
        </v-col>

        <v-col cols="12" md="3" xl="3" sm="12" v-if="!isMedicoInterpreteSupervisor">
          <v-btn color="secondary" @click="setShowDialogStudies()" :disabled="reported">
            <v-icon left> mdi-information-outline </v-icon>
            Estudios realizados
          </v-btn>
        </v-col>

        <v-col cols="12" md="4" xl="4" sm="12" v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM_INT)">
          <v-btn color="secondary" @click="downloadZIP(model)" :disabled="reported">
            <v-icon left> mdi-folder-download </v-icon>
            Archivos DICOM
          </v-btn>
        </v-col>
        <v-col cols="12" md="3" xl="3" sm="12" v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)">
          <view-image-button :send="() => reported = !reported" :sending="reported" :idStudy="model.idStudy" />
        </v-col>
        <v-col cols="12" md="3" xl="3" sm="12" v-if="$utilFront.withPermission($prm.VIEWER_OSIRIX)">
          <v-btn color="blue-grey" dark @click="viewerOsirix(model)" :disabled="reported">
            <v-icon left> mdi-laptop </v-icon>
            Visualizador OsiriX
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" xl="4" sm="12" v-if="mastography && !isMedicoInterpreteSupervisor">
          <v-btn color="error" @click="downloadInterpretation(model)" :disabled="invalid || reported || !validBirads || !fillinterpretation
      ">
            <v-icon left> mdi-file-pdf-box </v-icon>
            Descargar
          </v-btn>
        </v-col>

        <v-col cols="12" md="4" xl="4" sm="12" v-if="!mastography">
          <v-btn color="error" @click="downloadInterpretation(model)"
            :disabled="invalid || reported || !fillinterpretation">
            <v-icon left> mdi-file-pdf-box </v-icon>
            Descargar
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" xl="4" sm="12" class="mt-4 mb-4">
          <v-btn color="success" @click="openSliderSaveTemplate()"
            :disabled="invalid || reported || !fillSaveTemplate">
            <v-icon color="white" dark left> mdi-note-text </v-icon>
            Guardar plantilla
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
    <v-dialog v-model="dialogImages" persistent max-width="800px" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="text-h6 text-center">
          imágenes de estudio
        </v-card-title>
        <v-card-text>
          ID Estudio: {{ model.idStudy }}
          <br />
          Paciente: {{ model.fullNamePatient }}
        </v-card-text>

        <div class="container">
          <div style="max-height: 400px" class="row overflow-y-auto">
            <div class="col-md-6" v-for="(n, index) in images" :key="index">
              <div style="justify-content: center; display: flex">
                <img :src="n.url" width="200px" />
                <v-checkbox style="margin-top: -10px" v-model="n.added" @change="addImageToList(n)"></v-checkbox>
              </div>
            </div>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogImages = false">
            Volver
          </v-btn>
          <v-btn color="primary" @click="addImages(), (dialogImages = false)">
            Agregar <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveTemplate" persistent max-width="800px" transition="dialog-top-transition">
      <v-card>
        <v-card-title>
          <h4>Guardar plantilla</h4>
        </v-card-title>
        <v-container>
          <!-- <validation-observer
            ref="observerDialogTemplate"
            v-slot="{ invalid }"
          > -->
          <!-- <v-form @submit.prevent="saveTemplate"> -->
          <v-card-text>
            <v-row>
              <v-col>
                <!-- <validation-provider
                      v-slot="{ errors }"
                      name="Nombre"
                      rules="required"
                    > -->
                <v-text-field v-model="modelDialog.nameTemplate" label="Nombre*" required autocomplete="off"
                  @change="checkIfFill()">
                </v-text-field>
                <!-- </validation-provider> -->
              </v-col>
              <v-col>
                <!-- <validation-provider
                      v-slot="{ errors }"
                      name="Tipo"
                      rules="required"
                    > -->
                <v-radio-group v-model="modelDialog.typeTemplate" row @change="checkIfFill()">
                  <v-radio label="Privado" color="success" value="1"></v-radio>
                  <v-radio label="Público" color="success" value="2"></v-radio>
                </v-radio-group>
                <!-- </validation-provider> -->
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" plain @click="dialogSaveTemplate = false">
                <v-icon left>mdi-chevron-left</v-icon> volver
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" @click="validateTemplateInfo()">
                {{ "Guardar" }}
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
          <!-- </v-form> -->
          <!-- </validation-observer> -->
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showModalTemplate" v-model="showModalTemplate" max-width="1200" persistent>
      <v-card>
        <crud-dialog-view :idModality="model.idModality" />
        <v-card-actions class="justify-end">
          <v-btn text @click="closeModalTemplates()" color="error">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showDialogStudies" v-model="showDialogStudies" persistent max-width="1200" transition="dialog-top-transition">
        <DialogStudy :setShowDialogStudies="setShowDialogStudies" :idPatient="model.idPatient"/>
    </v-dialog>
    <v-dialog v-model="dialogAttachments" max-width="600px">
  <v-card>
    <v-card-title class="text-h6">Archivos anexos</v-card-title>
    <v-divider></v-divider>

    <v-list two-line>
      <v-list-item v-for="(file, i) in attachments" :key="i">
        <v-list-item-icon>
          <v-icon color="red">mdi-file-pdf-box</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ file.fileName }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ file.registrationDate || "" }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn small text @click="viewAttachment(file)">
            Ver <v-icon right small>mdi-open-in-new</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="!attachments.length">
        <v-list-item-content>
          <v-list-item-title>No hay archivos disponibles</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="dialogAttachments = false">
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  </div>
</template>

<script>
import CrudDialogView from "@/app/views/crud/CrudDialogView.vue";
import ViewImageButton from "@/app/components/common/study/ViewImageButton.vue";
import {
  StudyRequest,
} from "@/core/request";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import DialogStudy from "./DialogStudy.vue";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    CrudDialogView,
    ViewImageButton,
    DialogStudy
  },
  props: {
    model: Object,
    modelDialog: Object,
    changeTemplateInterpretation: Function,
    isPDF: Function,
    downloadViewer: Function,
    downloadZIP: Function,
    downloadInterpretation: Function,
    viewerOsirix: Function,
    addImageToList: Function,
    addImages: Function,
    openDialog: Function,
    saveTemplate: Function,
    listTemplates: Array,
    listAllTemplatesToTable: Array,
    images: Array,
    imagesToAdd: Array,
    reported: Boolean,
    validBirads: Boolean,
    loadingImages: Boolean,
    flagComponents: Boolean,
    fillinterpretation: Boolean,
    fillSaveTemplate: Boolean,
    dialogViewer: Boolean,
    closeSliderSaveTemp: Boolean,
    mastography: Boolean,
    listAllTemplates: Function,
  },
  data() {
    return {
      dialogImages: false,
      dialogSaveTemplate: false,
      saveTemplateFlag: false,
      showModalTemplate: false,
      showDialogStudies: false,
      idModality: "",
      dialogAttachments: false,
      attachments: [],       
      // headersTemplate: [
      //   { text: "Nombre", value: "name" },
      //   { text: "Id Plantilla", value: "idTemplateInterpretation" },
      //   { text: "Acciones", value: "actions", width: "20%" },
      // ],
    };
  },
  watch: {
    closeSliderSaveTemp: function () {
      if (this.closeSliderSaveTemp) {
        this.closeSliderSaveTemplate();
      }
    },
  },
  computed: {
    isMedicoInterpreteSupervisor() {
      const roleRaw = (this.$utilFront.getRole?.() || "");

      const role = roleRaw
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

      return role === "medico interprete supervisor";
    }
  },
  mounted() {
    this.saveTemplateFlag = false;
  },
  methods: {
    setShowDialogStudies() {
      this.showDialogStudies = !this.showDialogStudies;
    },
    seeOrHideViewer() {
      if (this.dialogViewer) {
        this.$emit("seeOrHideViewer", false);
      } else {
        this.$emit("seeOrHideViewer", true);
      }
    },
    checkIfFill() {
      if (this.modelDialog.nameTemplate == undefined) {
        return (this.saveTemplateFlag = false);
      } else {
        if (this.modelDialog.typeTemplate == null) {
          this.saveTemplateFlag = false;
        } else {
          this.saveTemplateFlag = true;
        }
      }
    },
    openSliderImages () {
  /* Reiniciar flags y lista cada vez */
  this.images.forEach(img => { img.added = false })
  if (Array.isArray(this.imagesToAdd)) this.imagesToAdd.length = 0

   this.dialogImages = true
},
    openSliderSaveTemplate() {
      this.saveTemplateFlag = false;
      this.dialogSaveTemplate = true;
    },
    closeSliderSaveTemplate() {
      this.dialogSaveTemplate = false;
      this.saveTemplateFlag = false;
      this.modelDialog.nameTemplate = "";
      this.modelDialog.typeTemplate = null;
    },
    validateTemplateInfo() {
      if (this.saveTemplateFlag == true) {
        this.saveTemplate();
      } else {
        this.$utilFront.notifications(
          "Datos de plantilla no correctos, verifique la información.",
          "ERROR"
        );
      }
    },
    closeModalTemplates() {
      this.showModalTemplate = false;
      if (this.$utilFront.isNonNull(this.listAllTemplates)) {
        this.listAllTemplates();
      }
    },
    async openAttachments() {
      try {
        this.dialogAttachments = false;
        const { data } = await StudyRequest.papanicolaouViewReport({
          idStudy: this.model.idStudy,
          studyFiles: true
        });
        this.attachments = data.studyFiles || [];
        this.dialogAttachments = true;
      } catch (err) {
        console.error("Error al cargar archivos anexos:", err);
        this.$utilFront.notifications("No se pudieron cargar los archivos", "ERROR");
      }
    },

    // Se decodifica Base64 y abre el PDF
    viewAttachment(file) {
      try {
        const b64 = (file.bytes || "").replace(/\s+/g, "");
        const binary = atob(b64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
        const blob = new Blob([bytes], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "_blank");
      } catch (e) {
        console.error(e);
        this.$utilFront.notifications("No se pudo abrir el archivo", "ERROR");
      }
    },
     downloadZIP(item) {
    this.sending = true;
    try {
      let data = { idStudy: item.idStudy };
      DownloadZipRequest.downloadImagesDCM(data)
        .then((res) => {
          // Construir el nombre del archivo con el formato: Apellido(s)Nombre(s) - ID.zip
          let filename = '';
          
          if (item.fullNamePatient && item.idPatient) {
            const nameParts = item.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
            const numParts = nameParts.length;
            
            if (numParts === 1) {
              filename = `${nameParts[0]} - ${item.idPatient}.zip`;
            } else {
              // Determinar cuántos apellidos tiene (mínimo 1, máximo 3)
              let apellidosCount;
              
              if (numParts <= 3) {
                apellidosCount = 1;
              } else if (numParts <= 5) {
                apellidosCount = 2;
              } else {
                apellidosCount = 3;
              }
              
              const apellidos = nameParts.slice(-apellidosCount).join('');
              const nombres = nameParts.slice(0, -apellidosCount).join('');
              
              filename = `${apellidos}${nombres} - ${item.idPatient}.zip`;
            }
          } else {
            filename = `Estudio-${item.idStudy}.zip`;
          }

          const url = URL.createObjectURL(
            new Blob([res.data], { type: "application/zip" })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    } catch (e) {
      this.catchError(e);
    }
  },

  downloadInterpretation(item) {
    this.sending = true;
    let data = {
      idStudy: item.idStudy,
      interpretationText: "",
      fileName: "Interpretacion",
    };
    
    ReportPDFRequest.downloadInterpretation1(data).then((res) => {
      // Construir el nombre del archivo con el formato: Apellido(s)Nombre(s) - ID.pdf
      let filename = '';
      let displayName = '';
      
      if (item.fullNamePatient && item.idPatient) {
        const nameParts = item.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
        const numParts = nameParts.length;
        
        if (numParts === 1) {
          filename = `${nameParts[0]} - ${item.idPatient}.pdf`;
          displayName = `${nameParts[0]} - ${item.idPatient}`;
        } else {
          let apellidosCount;
          
          if (numParts <= 3) {
            apellidosCount = 1;
          } else if (numParts <= 5) {
            apellidosCount = 2;
          } else {
            apellidosCount = 3;
          }
          
          const apellidos = nameParts.slice(-apellidosCount).join('');
          const nombres = nameParts.slice(0, -apellidosCount).join('');
          
          filename = `${apellidos}${nombres} - ${item.idPatient}.pdf`;
          displayName = `${apellidos}${nombres} - ${item.idPatient}`;
        }
      } else {
        filename = `Interpretacion-${item.idStudy}.pdf`;
        displayName = `Interpretacion-${item.idStudy}`;
      }

      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName}</title>
    <style>
        body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
        embed { width: 100%; height: 100%; border: none; }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const htmlUrl = URL.createObjectURL(htmlBlob);
      window.open(htmlUrl, '_blank');

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
        URL.revokeObjectURL(htmlUrl);
      }, 60000);

      this.sending = false;
    }).catch(error => {
      this.sending = false;
      this.catchError(error);
    });
  }
  },
};
</script>

<style></style>
